import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable}     from 'rxjs/Observable';
import {Tag} from './tag';
import { TranslateService } from 'ng2-translate';
const json = require("json!./../../../resources/properties.json");

@Injectable()
export class TagsService {

    private _tagsUrl = '/tagsData';    
    private serverURL: string; 

    constructor(private _translateService: TranslateService, private http: Http) {         
        this.serverURL = json.api_url;
    }

    getTagsOrderedByUsage() {            

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        let options = new RequestOptions({ headers: authHeader, body: "" });

        var language = this._translateService.currentLang;

        return this.http.get(this.serverURL + this._tagsUrl + "/orderedByUsage/" + language, options).toPromise().then(res => { 
                        
            if(JSON.parse(res.text()).code == 1) {
            
                return JSON.parse(res.text()).rows;

            }
        
        }, this.handleError);

    }    

    getTagsOrderedByName() {
        
        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});

        if(token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }

        let options = new RequestOptions({ headers: authHeader, body: ""});
        var language = this._translateService.currentLang;

        return this.http.get(this.serverURL + this._tagsUrl + "/orderedByName/" + language, options).toPromise().then(res => {
            if(JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            }
        }, this.handleError);

    }

    private handleError(error: any) {

        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);

    }

    private serializeObj(obj: any) {

        var result: any[] = [];        

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");

    }    

    private serializeTags(tags: any) {

        var result: any[] = [];        

        for (var i = 0; i < tags.length; i++) {

            result.push("tags[]=" + tags[i].id);

        }

        return result.join("&");

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/tags.service.ts
 **/